export const CRICKET="cricket";
export const TENNIS="tennis";
export const SOCCER="soccer";
